import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
    paddingBottom: '12px',
    borderBottom: '1px solid var(--color-neutral-150)'
  },
  headerTitle: {
    fontWeight: 600,
    fontSize: '13px',
    color: 'var(--color-success-700)'
  },
  headerMeta: {
    fontSize: '12px',
    color: 'var(--text-color-subtle)'
  },
  sectionLabel: {
    fontSize: '10px',
    fontWeight: 700,
    color: 'var(--text-color-subtle)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '4px'
  },
  pre: {
    margin: 0,
    padding: '10px',
    fontSize: '11px',
    lineHeight: 1.5,
    backgroundColor: 'var(--color-neutral-050)',
    border: '1px solid var(--color-neutral-150)',
    borderRadius: '6px',
    overflow: 'auto',
    maxHeight: '300px',
    fontFamily: 'monospace'
  },
  section: {
    '&:not(:last-child)': {
      marginBottom: '16px'
    }
  }
}))

function SubmitResultsPanel ({ result }) {
  const classes = useStyles()
  if (!result) return null

  return (
    <div>
      <div className={classes.header}>
        <span className={classes.headerTitle}>Submission Captured</span>
        <span className={classes.headerMeta}>
          {result.actionPipelineCode} &middot; {new Date(result.timestamp).toLocaleTimeString()}
        </span>
      </div>
      <div className={classes.section}>
        <div className={classes.sectionLabel}>Pipeline Args</div>
        <pre className={classes.pre}>{JSON.stringify(result.args, null, 2)}</pre>
      </div>
      <div className={classes.section}>
        <div className={classes.sectionLabel}>Arg Mapping</div>
        <pre className={classes.pre}>{JSON.stringify(result.argMapping, null, 2)}</pre>
      </div>
    </div>
  )
}

SubmitResultsPanel.propTypes = {
  result: PropTypes.shape({
    args: PropTypes.object,
    argMapping: PropTypes.object,
    actionPipelineCode: PropTypes.string,
    timestamp: PropTypes.string
  })
}

export default SubmitResultsPanel
